import React from 'react';

import { isDeviceLandScape } from '../../../base/environment/environment';
import { translate } from '../../../base/i18n';
import {
    Icon,
    IconHorizontalView,
    IconStageView,
    IconVerticalView,
    TileViewIcon
} from '../../../base/icons';
import { connect } from '../../../base/redux';
import { getBrandingColorPalette } from '../../../base/styles';
import Tooltip from '../../../base/tooltip/components/Tooltip';
import TileRangeSlider from '../../../filmstrip/components/web/TileRangeSlider';
import { showNotification } from '../../../notifications';
import { toggleToolboxVisible } from '../../../toolbox/actions.web';
import { LAYOUTS, setTileView } from '../../../video-layout';
import { handleSelectLayout } from '../../filmStripViewManager';
import AbstractLabels from '../AbstractLabels';

declare var interfaceConfig: Object;

/**
 * The SelectLabels component of the Web application.
 */
class SelectLabels extends AbstractLabels<Props, State> {

    /**
     * Constructor for SelectLabels
     *
     *
     * @augments Component
     */
    constructor(props: Props) {
        super(props);

        this.state = {
            filmstripBecomingVisible: false,
            viewStripMenu: false,
            FeaturedIcon: undefined
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this._onHandleViewStripMenu = this._onHandleViewStripMenu.bind(this);
        this._onHandleViewStripState = this._onHandleViewStripState.bind(this);
    }

    /** * Handles the state change of the filmstrip view.
     * @param {string} state - The new state of the filmstrip view.
     * @returns {void}
     */
    _onHandleViewStripState(state) {
        const accepted = handleSelectLayout(this.props.dispatch, state, this.props._participantsLength);

        this.setState({ viewStripMenu: false });

        // Call the callback prop to notify parent component
        if (this.props.onViewStripMenuChange) {
            this.props.onViewStripMenuChange(false);
        }

        if (!accepted) {
            this.props.dispatch(setTileView(false));
            this.props.dispatch(showNotification({
                description: this.props.t('toolbar.tileviewdisableddescription'),
                titleKey: this.props.t('toolbar.tileviewdisabled')
            }, 5000));
        }
    }

    /** * Handles clicks outside the component to close the menu.
     * @param {MouseEvent} event - The mouse event.
     * @returns {void}
     */
    handleClickOutside(event) {
        const isSliderElement = event.target.classList?.contains('tile-range-slider-input')
            || event.target.closest('.tile-range-slider-item');
        const isToggleButton = event.target.closest('.select-label-responsive');

        if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target) && !isSliderElement && !isToggleButton) {
            this.setState({ viewStripMenu: false });

            // Call the callback prop to notify parent component
            if (this.props.onViewStripMenuChange) {
                this.props.onViewStripMenuChange(false);
            }
        }
    }

    /** * Toggles the visibility of the view strip menu.
     * @returns {void}
     */
    _onHandleViewStripMenu() {
        this.setState(prevState => {
            const newViewStripMenu = !prevState.viewStripMenu;

            // Call the callback prop to notify parent component
            if (this.props.onViewStripMenuChange) {
                this.props.onViewStripMenuChange(newViewStripMenu);
            }

            return {
                viewStripMenu: newViewStripMenu
            };
        });
        this.props.dispatch(toggleToolboxVisible(true));
    }

    /** * Lifecycle method that adds an event listener for clicks outside the component.
     * @returns {void}
     */
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    /** * Lifecycle method that removes the event listener for clicks outside the component.
     * @returns {void}
     */
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /** * Renders the component.
     * @returns {ReactElement}
     */
    render() {
        const { _filmStripView, t, conferenceView, _visibleButtons, _isPictureInPictureVisible } = this.props;
        const { viewStripMenu } = this.state;
        const isFolatView = conferenceView === 'float';


        const filmStripMenuButtonStyle = {
            background: interfaceConfig.applyMeetingSettings ? `${getBrandingColorPalette(interfaceConfig)?.secondary}` : '',
            color: interfaceConfig.applyMeetingSettings ? `${getBrandingColorPalette(interfaceConfig)?.accent1}` : '',
            fill: interfaceConfig.applyMeetingSettings ? `${getBrandingColorPalette(interfaceConfig)?.accent1}` : ''
        };
        const filmStripMenuButtonStyle1 = {
            background: interfaceConfig.applyMeetingSettings ? `${getBrandingColorPalette(interfaceConfig)?.accent1}` : '',
            color: interfaceConfig.applyMeetingSettings ? `${getBrandingColorPalette(interfaceConfig)?.primary}` : '',
            fill: interfaceConfig.applyMeetingSettings ? `${getBrandingColorPalette(interfaceConfig)?.primary}` : ''
        };
        const filmStripMenuDialogStyle = {
            background: interfaceConfig.applyMeetingSettings ? `${getBrandingColorPalette(interfaceConfig)?.primary}` : '',
            display: viewStripMenu ? 'flex' : 'none'
        };
        const layoutMenuButtonStyle = {
            background: interfaceConfig.applyMeetingSettings ? `${getBrandingColorPalette(interfaceConfig)?.accent1}` : ''
        };

        const layoutStyle = {
            display: 'flex',
            flexDirection: 'column',
            gap: '2px'
        };

        return (
            <div
                className = 'select-label-responsive-container'
                style = { layoutStyle }>
                <Tooltip
                    content = { t('tooltip.layouts') }
                    position = { 'top' }>
                    <div
                        className = { `select-label-responsive ${viewStripMenu ? 'menu-on' : ''} ${isFolatView ? 'is-float-view toolbox-icon' : 'video_space-view_strip'}` }
                        onClick = { this._onHandleViewStripMenu }
                        style = { isFolatView ? null : layoutMenuButtonStyle }>
                        <div className = { 'video_space-icon ' }>
                            <Icon
                                src = {
                                    _filmStripView === LAYOUTS.STAGE_VIEW
                                        ? IconStageView
                                        : _filmStripView === LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW
                                            ? IconHorizontalView
                                            : _filmStripView === LAYOUTS.VERTICAL_FILMSTRIP_VIEW
                                                ? IconVerticalView
                                                : _filmStripView === LAYOUTS.TILE_VIEW
                                                    ? TileViewIcon
                                                    : ''
                                }
                                width = { 20 } />
                        </div>
                        <p className = 'select-label-text'>{t('toolbar.layouts')}</p>
                    </div>
                </Tooltip>
                <div
                    className = 'video_space-view_strip-menu'
                    ref = { this.wrapperRef }
                    style = { filmStripMenuDialogStyle }>
                    {(_visibleButtons.has('stageview') || _visibleButtons.has('stage')) && (
                        <button
                            className = { _filmStripView === LAYOUTS.STAGE_VIEW ? `${_filmStripView} selected` : null }
                            onClick = { () => this._onHandleViewStripState(LAYOUTS.STAGE_VIEW) }
                            style = { _filmStripView === LAYOUTS.STAGE_VIEW ? filmStripMenuButtonStyle : filmStripMenuButtonStyle1 }>
                            <Icon
                                fillColor = { _filmStripView === LAYOUTS.STAGE_VIEW ? filmStripMenuButtonStyle : filmStripMenuButtonStyle1 }
                                src = { IconStageView }
                                width = { 20 } />
                            <p>{t('toolbar.layoutStage')}</p>
                        </button>
                    )}
                    {this.props.screenSize ? null
                        : (_visibleButtons.has('filmstrip') || _visibleButtons.has('verticalview')) && !_isPictureInPictureVisible && <button
                            className = { _filmStripView === LAYOUTS.VERTICAL_FILMSTRIP_VIEW ? `${_filmStripView} selected` : null }
                            onClick = { () => this._onHandleViewStripState(LAYOUTS.VERTICAL_FILMSTRIP_VIEW) }
                            style = { _filmStripView === LAYOUTS.VERTICAL_FILMSTRIP_VIEW ? filmStripMenuButtonStyle : filmStripMenuButtonStyle1 }>
                            <Icon
                                fillColor = { _filmStripView === LAYOUTS.VERTICAL_FILMSTRIP_VIEW ? filmStripMenuButtonStyle : filmStripMenuButtonStyle1 }
                                src = { IconVerticalView }
                                width = { 20 } />
                            <p>{t('toolbar.layoutVertical')}</p>
                        </button>}

                    {!isDeviceLandScape() && (_visibleButtons.has('horizontalstrip') || _visibleButtons.has('horizontalview')) && <button
                        className = { _filmStripView === LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW ? `${_filmStripView} selected` : null }
                        onClick = { () => this._onHandleViewStripState(LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW) }
                        style = { _filmStripView === LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW ? filmStripMenuButtonStyle : filmStripMenuButtonStyle1 }>
                        <Icon
                            fillColor = { _filmStripView === LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW ? filmStripMenuButtonStyle : filmStripMenuButtonStyle1 }
                            src = { IconHorizontalView }
                            width = { 20 } />
                        <p>{t('toolbar.layoutHorizontal')}</p>
                    </button>
                    }
                    {_visibleButtons.has('tileview') && <button
                        className = { _filmStripView === LAYOUTS.TILE_VIEW ? `${_filmStripView}` : '' }
                        onClick = { () => this._onHandleViewStripState(LAYOUTS.TILE_VIEW) }
                        style = { _filmStripView === LAYOUTS.TILE_VIEW ? filmStripMenuButtonStyle : filmStripMenuButtonStyle1 }>
                        <Icon
                            fillColor = { _filmStripView === LAYOUTS.TILE_VIEW ? filmStripMenuButtonStyle : filmStripMenuButtonStyle1 }
                            src = { TileViewIcon }
                            width = { 20 } />
                        <p>{t('toolbar.layoutTile')}</p>
                    </button>}
                    {_visibleButtons.has('tileview') && <button
                        className = { `${_filmStripView} tile-view-button` }
                        style = { filmStripMenuButtonStyle }>
                        <TileRangeSlider />
                    </button>}
                </div>
            </div>
        );
    }
}

export default connect()(translate(SelectLabels));
